












import {
  Component,
  Vue,
  Emit,
  Prop,
  Provide,
  Watch
} from "vue-property-decorator";
import { State, Getter, Action, namespace } from "vuex-class";
import Loader from "@/components/Loader.vue";
import { IProperty } from "../../models/interfaces/property/property.model.interface";

const PublisherModule = namespace("publisherModule");

@Component({
  components: {
    Loader
  }
})
export default class RevenueStreamTable extends Vue {

    get getRevenueData(): any[] {
        return [
            { revenuestream: "Facebook License Fee", amount: "£4,000 (per month)" }
        ];
  }

  get getSelectedProperty(): IProperty | null {
    return this.selectedProperty;
  }

  get isHonestJohn() {
    if (this.property) {
      return this.property.publisherId === 18;
    } else {
      return false;
    }
  }
  @PublisherModule.Getter public selectedProperty: IProperty | null;

  @Prop({ default: false })
  public hover: boolean;

  @Prop({ default: false })
  public striped: boolean;

  @Prop({ default: false })
  public bordered: boolean;

  @Prop({ default: false })
  public small: boolean;

  @Prop({ default: false })
  public fixed: boolean;

  @Prop({ default: "Table" })
  public caption: string;

  public items: any[] = [];

  public property: IProperty | null = null;

  public columns = [
    {
      key: "revenuestream",
      label: "Revenue Stream"
    },
    {
      key: "amount",
      label: "Amount"
    }
  ];

  @Watch("getSelectedProperty")
  public onSelectedPropertyChanged() {
    this.property = this.getSelectedProperty;
  }

    public updateRevenueData() {
        this.items = this.getRevenueData;
    }

    public created() {
        this.property = this.getSelectedProperty;
        this.updateRevenueData();
  }
}
